export const DATE_COLUMN_WIDTH = 110;
export const DATA_COLUMN_WIDTH = 345;
export const MIN_DATA_COLUMN_WIDTH = 60;
export const MAX_DATA_COLUMN_WIDTH = 520;
export const RESIZE_KEYBOARD_STEP = 16;
export const DEFAULT_VIRTUAL_RECT = { width: 1024, height: 600 };
export const COLUMN_WIDTHS_STORAGE_KEY = 'spot-history-table-column-widths';
export const COLUMN_PADDING_X = '10px';
export const COLUMN_GAP = 24;
